import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.approve.modal.title',
        defaultMessage: 'Waiting for approval',
    },
    empty: {
        id: 'cards.approve.modal.empty',
        defaultMessage: 'No transactions yet',
    },
})
